import { useIsMutating, useMutation } from '@tanstack/react-query';
import CarrierService from '../../services/settings/ppoints/CarrierService';

export const useCarrierService = () => {
    const keys = {
        createKey: 'carrier-service-create-mutation',
        deleteKey: 'carrier-service-delete-mutation',
    };

    const createCarrierServiceMutation = useMutation({
        mutationKey: [keys.createKey],
        mutationFn: () => CarrierService.createService(),
    });
    const deleteCarrierServiceMutation = useMutation({
        mutationKey: [keys.deleteKey],
        mutationFn: () => CarrierService.deleteService(),
    });

    const mutating = {
        [keys.createKey]: useIsMutating([keys.createKey]),
        [keys.deleteKey]: useIsMutating([keys.deleteKey]),
    };

    return {
        createCarrierServiceMutation,
        deleteCarrierServiceMutation,
        isLoading: mutating[keys.createKey] > 0 || mutating[keys.deleteKey] > 0,
    };
};
